import { Routes, Route, useNavigate, useLocation, Link } from 'react-router-dom'
import { Button, Progress } from 'reactstrap'
import { Suspense, lazy } from 'react'
import Header from './components/Header'
import States from "./components/States"
import Question from "./components/Question";
import { useEffect, useState } from 'react'
import './App.scss'

const AddQuestion = lazy(() => import("./components/AddQuestion"))
const Finish = lazy(() => import("./components/Finish"))


function App() {
    const navigate = useNavigate();
    const location = useLocation();
    const [currentIdx, setCurrentIdx] = useState(0)
    const [totalAnswered, setTotalAnswered] = useState(0)
    const [totals, setTotals] = useState({})
    const [winners, setWinners] = useState([])
    const [questions, setQuestions] = useState([
        {
            id: 1,
            text: "Type of weather",
            answers: [
                {text: "Super cold and super chill bro", value: "CO"},
                {text: "Bring on the heat, humidity, ....and a pool", value: "TX"},
                {text: "75 and cool ocean breezes", value: "CA"}
            ],
            selectedAnswer: ""
        },
        {
            id: 2,
            text: "How you livin'",
            answers: [
                {text: "I'll live in the mountains and eat grubs", value: "CO"},
                {text: "Wide open spaces", value: "TX"},
                {text: "Yowza, $3650/month for a 2bd/1ba!", value: "CA"}
            ],
            selectedAnswer: ""
        },
        {
            id: 3,
            text: "What do you want to eat",
            answers: [
                {text: "Rocky mountain oysters", value: "CO"},
                {text: "Does that come with BBQ sauce?", value: "TX"},
                {text: "Pico de freako", value: "CA"}
            ],
            selectedAnswer: ""
        },
        {
            id: 4,
            text: "Free time",
            answers: [
                {text: "Strap some planks and get to the backcountry", value: "CO"},
                {text: "What can I shoot?", value: "TX"},
                {text: "This next set is head high dude", value: "CA"}
            ],
            selectedAnswer: ""
        },
        {
            id: 5,
            text: "What's your jam",
            answers: [
                {text: "Anything with a 15 minute drum solo", value: "CO"},
                {text: "Put some honky in my tonky", value: "TX"},
                {text: "Make me a mix tape", value: "CA"}
            ],
            selectedAnswer: ""
        }
    ])

    // set question
    const setQuestion = (id, answer) => {
        setQuestions(questions.map((question) => question.id === id ? {...question, selectedAnswer: answer} : question))
    }

    // add question
    const addQuestion = (question) => {
        const newQuestion = {id: questions.length + 1, ...question};
        setQuestions([...questions, newQuestion])
    }

    useEffect(() => {
        updateTotals()
    }, [questions]);

    // calculate percentage of questions answered
    const percentQuestionAnswered = () => {
        return (questions.filter((question) => question.selectedAnswer).length / questions.length) * 100
    }

    // update totals
    const updateTotals = () => {
        let counts = {
            CA: 0,
            CO: 0,
            TX: 0
        }
        let totalAnswered = 0

        questions.forEach(function (question) {
            if (question.selectedAnswer) {
                counts[question.selectedAnswer] += 1
                totalAnswered += 1
            }
        })

        setTotals(counts)
        setTotalAnswered(totalAnswered)
    }

    // calculate winner
    const calcWinner = () => {
        let winners = [],
            maxValue = 0;

        Object.keys(totals).forEach((state) => {
            const value = totals[state]

            if (value > maxValue) {
                winners = [state]
                maxValue = value
            } else if (value === maxValue) {
                winners.push(state)
            }
        })

        setWinners(winners);
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <Header />
                    <div className="wrapper">
                        <div className="row">
                            <div className="col-md-6 mb-2 mb-md-3">
                                <Progress striped style={{height: 25}} value={percentQuestionAnswered()}>{percentQuestionAnswered()}%</Progress>
                            </div>
                            <div className="col-md-6 mb-2 text-end">
                                <Link to="/add">Add Question</Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-end" style={{minHeight: 130}}>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <Routes>
                                            <Route path='/' exact element={<Question question={questions[currentIdx]} onChange={setQuestion} />}  />
                                            <Route path='add' element={<AddQuestion totals={totals} onAdd={addQuestion} />} />
                                            <Route path='finish' element={<Finish winners={winners} />} />
                                        </Routes>
                                    </Suspense>
                                    <States totals={totals} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Button color='primary'
                            onClick={() => {
                                if (location.pathname !== '/') {
                                    navigate('/')
                                } else {
                                    setCurrentIdx(currentIdx <= 0 ? 0 : currentIdx - 1)
                                }
                            }}
                            disabled={currentIdx === 0 && location.pathname !== '/finish'}>Previous</Button>
                    <Button className='ms-1' color='primary'
                            onClick={() => setCurrentIdx(currentIdx >= questions.length - 1 ? questions.length - 1 : currentIdx + 1)}
                            disabled={currentIdx === questions.length - 1 || location.pathname !== '/'}>Next</Button>
                    <Button className='ms-1' color='success'
                            onClick={() => {
                                calcWinner();
                                navigate('/finish')
                            }}
                            style={{display: totalAnswered === questions.length ? 'inline' : 'none'}}>Finish</Button>
                </div>
            </div>
        </div>
    );
}

export default App;
